export default __webpack_public_path__ + "static/solutions-acquisition-outline.url-872607ad70483fa98de283c79ed62201.svg";